<h2 mat-dialog-title>Create league</h2>
<mat-dialog-content>
  <form [formGroup]="formData" (ngSubmit)="create()" class="create-league-form">
    <mat-form-field appearance="fill">
      <mat-label>WBSC league URL</mat-label>
      <input type="text" matInput formControlName="url"
             placeholder="https://www.wbsceurope.org/en/events/...">
    </mat-form-field>
    <mat-checkbox formControlName="licenced">Licenced</mat-checkbox>
    <p class="hint">
      Zadej URL ligy z WBSC a ulož — server z WBSC automaticky doplní id, název,
      federaci, loga a seznam týmů (do ~30 s). Pak ligu otevři v seznamu a doplň
      barvy/loga týmů.
    </p>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button"
          [disabled]="!formData.valid || saving" (click)="create()">Create</button>
</mat-dialog-actions>
